// Defines the canonical menu order for sidebar navigation
// Menu items will be displayed in this exact order
export const MENU_ORDER = [
  'Dashboard',
  'Place An Order',
  'Existing Orders',
  'Deleted Orders',
  'Sales Customer Info',
  'Estimating Customer Info',
  'Pricing Contracts',
  'Product Catalog',
  'Labor Catalog',
  'Kits',
  'Admin'
];

// Create a map for O(1) lookup during sorting
// This maps menu names to their display order index
export const MENU_ORDER_MAP = MENU_ORDER.reduce((acc, name, index) => {
  acc[name] = index;
  return acc;
}, {});
